export default __webpack_public_path__ + "static/media/icons8-plus-math-96.296ebbba.svg";